import { MapContainer, TileLayer } from 'react-leaflet';

import { GetAllSitesExtended } from '@/api/fe-api/view/queries/get-all-sites-extended';
import { LoadError } from '@/components/ui/load-error';
import { MapBounds } from '@/modules/documents/view/components/pages/map/map-bounds';
import { MapSite } from '@/modules/documents/view/components/pages/map/map-site';

export function SiteListMapView() {
  const allSites = GetAllSitesExtended.useQuery();
  return (
    <div className="h-[70vh] w-full">
      <h2 className="mb-4 text-2xl font-semibold">Map of Assets</h2>
      {allSites.isError ? (
        <div className="relative">
          <div className="absolute inset-0 z-10">
            <LoadError title="An error occurred while fetching asset list" />
          </div>
        </div>
      ) : null}
      <MapContainer className="z-0 size-full font-sans">
        <MapBounds sites={allSites.data ?? []} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {allSites.data?.map((site) => (
          <MapSite key={site.id} sitePreview={site} />
        ))}
      </MapContainer>
    </div>
  );
}
